import { render } from "./SummaryQuestion.vue?vue&type=template&id=c35e7ca8&ts=true"
import script from "./SummaryQuestion.vue?vue&type=script&lang=ts"
export * from "./SummaryQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__